import { TextButton } from '@/components/common/text-button';

import { COMMAND_TYPE, type CommandType } from '../constants';

import styles from './queued-command-banner.module.scss';

/** Copy the AC specifies verbatim (US-112437 §9). */
const BANNER_COPY: Record<CommandType, { title: string; body: string }> = {
  [COMMAND_TYPE.TURN_ON]: {
    title: 'Turn On Queued',
    body: 'Device will be turned on when it comes online',
  },
  [COMMAND_TYPE.TURN_OFF]: {
    title: 'Turn Off Queued',
    body: 'Device will be turned off when it comes online',
  },
};

export type QueuedCommandBannerProps = {
  type: CommandType;
  /** Absent when the server gave no command id — see the note below. */
  onCancel?: () => void;
};

/**
 * The full-width queued-command banner (US-112437 §9). It stays up until the command executes or
 * is cancelled, and only ever one command can be queued at a time.
 *
 * Cancel is **omitted when the server sent no command id**: `DELETE .../commands/{commandId}`
 * needs one, and offering a button that cannot complete would be worse than not offering it.
 */
export function QueuedCommandBanner({ type, onCancel }: QueuedCommandBannerProps) {
  const copy = BANNER_COPY[type];

  return (
    <section className={styles.banner} role="status">
      <div className={styles.text}>
        <p className={styles.title}>{copy.title}</p>
        <p className={styles.body}>{copy.body}</p>
      </div>
      {onCancel ? (
        <TextButton tone="danger" className={styles.cancel} onClick={onCancel}>
          Cancel
        </TextButton>
      ) : null}
    </section>
  );
}
